import React, {useEffect, useState} from "react";
import "../../../../assets/css/public.scss";
import {Link} from "react-router-dom";
import logo from "../../../../assets/images/logo.svg";
import {ChevronsUp, Facebook, Filter, Instagram, Menu, Search, ShoppingBag, User, X, Youtube} from "react-feather";
import {route, trans, widget} from "../../../modulesCompiler";
import PublicHeaderNav from "./PublicHeaderNav";
import Drawer from "rc-drawer";
import {useSwipeable} from "react-swipeable";


import {GA4React} from "ga-4-react";

const ga4react = new GA4React(
    'G-KVMQRGJ7ZJ',
    { /* ga custom config, optional */ },
    [ /* additional code, optional */ ],
    5000 /* timeout, optional, defaults is 5000 */,
    //options /* { nonce: ['first-script-is-async','second-script'] } */
);

ga4react.initialize().then((ga4) => {
    ga4.pageview('path')
    ga4.gtag('event','pageview','path') // or your custom gtag event
},(err) => {
    console.error(err)
})


const PublicLayout = (props) => {
    let Component = props.component;
    const [stickyHeader, setStickyHeader] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const dateYear = new Date().getFullYear()
    const swipeRightToClose = useSwipeable({
        onSwipedRight: (eventData) => setDrawerOpen(false),
    });

    useEffect(() => {
        window.onscroll = function(ev) {
            if (window.pageYOffset > 200) {
                setStickyHeader(true);
            } else  {
                setStickyHeader(false);
            }
        };
    },[]);

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div>
            <Drawer
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                handler={null}
                className="d-md-none" placement="right" level={null} width="80vw">
                <button onClick={()=>setDrawerOpen(false)}
                        className="btn btn-link position-absolute" style={{bottom: 10, right: 10}}>
                    <X size={20} strokeWidth={3} />
                </button>

                <div {...swipeRightToClose} className="h-100 header_menu">
                    <div className="text-center">
                        <Link to={route("public.index")}>
                            <img src={logo} alt="BAROK 032" width={130} />
                        </Link>
                    </div>
                    <PublicHeaderNav />
                </div>
            </Drawer>

            <header className="border-bottom shadow-sm">
                <div className="border-bottom">
                    <div className="container pt-2 pb-2 d-md-flex text-center text-md-left align-items-center justify-content-between">
                        <div className="mb-3 mb-md-0">
                            <Link className="logo-wrapper" to={route("public.index")}>
                                <img src={logo} alt="BAROK 032" width={130} />
                                <div className="title-wrapper">
                                    <p className="fw-bold title-text">Veleprodaja</p>
                                </div>
                            </Link>
                        </div>

                        {widget("products.SearchModal", {
                            button: <button className="btn btn-link btn-link-dark text-white ms-2">
                                <Search size={24} />
                            </button>
                        })}

                        <div className="d-none d-md-block">
                            {widget("users.HeaderLoginLink")}
                            {widget("orders.HeaderBasketLink", {
                                button: <button className="btn btn-link shadow-none">
                                    <ShoppingBag size={24} />
                                </button>
                            })}
                        </div>
                    </div>
                </div>

                <div className={`${stickyHeader ? "scroll_menu_fixed shadow-sm bg-white" : ""}`}>
                    <div className="pt-md-2 pb-md-2 d-none container d-md-flex align-items-center weight_500 link_gray top-0 bg-white w-100">
                        <PublicHeaderNav />
                    </div>
                </div>
                {stickyHeader &&
                <div style={{height: 60}} />}
            </header>

            <div className="mobile_menu d-md-none shadow-sm rounded-3 border border-primary">
                <div className="row g-0 text-center text-uppercase fs-s fw-bold">
                    <div className="col">
                        {widget("users.HeaderLoginLink", {
                            button: <Link to={route("users.login")} className="btn btn-link btn-sm w-100 shadow-none">
                                <User size={18} strokeWidth={3} />
                                <div className="text-uppercase fw-bold fs-xs">
                                    Nalog
                                </div>
                            </Link>
                        })}
                    </div>
                    <div className="col">
                        {widget("orders.HeaderBasketLink", {
                            button: <button className="btn btn-link btn-sm w-100 shadow-none">
                                <ShoppingBag size={18} strokeWidth={3} />
                                <div className="text-uppercase fw-bold fs-xs">
                                    Korpa
                                </div>
                            </button>
                        })}
                    </div>
                    <div className="col">
                        <button onClick={() => setDrawerOpen(true)}
                                className="btn btn-link btn-sm w-100 shadow-none">
                            <Menu size={18} strokeWidth={3} />
                            <div className="text-uppercase fw-bold fs-xs">
                                {trans("strane")}
                            </div>
                        </button>
                    </div>
                    <div className="col">
                        {widget("categories.CategoriesDrawer", {
                            button: <button className="btn btn-link btn-sm w-100 shadow-none">
                                <Filter size={18} strokeWidth={3} />
                                <div className="text-uppercase fw-bold fs-xs">
                                    {trans("kategorije")}
                                </div>
                            </button>
                        })}
                    </div>
                    {stickyHeader &&
                    <div className="col">
                        <button onClick={scrollToTop} className="btn btn-link w-100 h-100 shadow-none">
                            <ChevronsUp />
                        </button>
                    </div>}
                </div>
            </div>


            <div className="bg-light border border-light">
                <div style={{minHeight: 600}}>
                    <Component {...props} />
                </div>
            </div>

            <footer className="border-top">
                <div className="container d-md-flex text-center text-md-left align-items-center justify-content-between mt-3 pb-3">
                    <div className="mb-3 mb-md-0" style={{fontSize: 13}}>
                        <a href="/politika-privatnosti" className="superweb ms-1">
                            Politika Privatnosti
                        </a>
                    </div>
                    <div className="mb-3 mb-md-0" style={{fontSize: 13}}>
                        BAROK 032 DOO {dateYear}
                        <div className="d-md-none mb-2" />- maintained by
                        <a href="https://zoit.dev" className="superweb ms-1" target="_blank" rel="noreferrer">
                            ZoIT Solutions
                        </a>
                    </div>
                    <div className="mb-6 mb-md-0">
                        Pratite nas: <div className="d-md-none mb-2" />
                        {/*<a href="https://facebook.com" className="ms-2" target="_blank" rel="noreferrer">
                            <Facebook size={20} />
                        </a>
                       <a href="https://youtube.com" className="ms-2" target="_blank" rel="noreferrer">
                            <Youtube size={20} />
                        </a>*/}
                        <a href="https://www.instagram.com/barok032" className="ms-2" target="_blank" rel="noreferrer">
                            <Instagram size={20} />
                        </a>
                    </div>
                </div>
            </footer>

            {stickyHeader &&
            <button onClick={scrollToTop}
                    className="btn btn-secondary position-fixed shadow-none d-none d-md-block" style={{right: 15, bottom: 30}}>
                <ChevronsUp />
            </button>}

            {widget("orders.BagBar")}
            {widget("orders.BasketDrawer")}
        </div>
    )
}

export default PublicLayout;
